
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.85 29.041H2.151A1.163 1.163 0 011 27.868V2.215a1.164 1.164 0 011.151-1.174A1.163 1.163 0 013.3 2.215v24.48h24.55a1.173 1.173 0 010 2.346zM6.6 24.192a1.139 1.139 0 01-.726-.264 1.191 1.191 0 01-.164-1.652l6.733-8.411a1.151 1.151 0 01.8-.428h.09a1.137 1.137 0 01.767.3l4.69 4.275 3.916-5.05-.275-.227-2.187-1.8c-.326-.27-.414-.6-.224-.838a.684.684 0 01.292-.2l7.811-2.911a.876.876 0 01.245-.037.6.6 0 01.452.186.752.752 0 01.18.561l-1.163 8.394a.721.721 0 01-.134.334.429.429 0 01-.346.167.823.823 0 01-.506-.216l-2.183-1.8-.169-.14-4.661 6.006a1.15 1.15 0 01-.8.441h-.1a1.14 1.14 0 01-.768-.3l-4.7-4.288-5.978 7.467a1.139 1.139 0 01-.892.431z","fill":"#222"}})])
          )
        }
      }
    